import { useEffect, useState } from 'react';
import { generateColor } from '../util';
function hasValue(value) {
    return value !== undefined;
}
const useColorState = (defaultStateValue, option) => {
    const { defaultValue, value } = option;
    const [colorValue, setColorValue] = useState(() => {
        let mergedState;
        if (hasValue(value)) {
            mergedState = value;
        }
        else if (hasValue(defaultValue)) {
            mergedState = defaultValue;
        }
        else {
            mergedState = defaultStateValue;
        }
        return generateColor(mergedState || '');
    });
    useEffect(() => {
        if (value) {
            setColorValue(generateColor(value));
        }
    }, [value]);
    return [colorValue, setColorValue];
};
export default useColorState;
